<template>
  <div>

    <vs-prompt
      title= "Générer lien de paiement"
      :active.sync="lienPaiementPrompt"
      :buttons-hidden="true"
      @close="closeLienPaiementPrompt"
    >

      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <p v-if="dataIntervention.invoice.id"><b>Montant : </b>{{ dataIntervention.invoice.ttc }} €</p>
          <vs-input label="Saisir le montant" v-model="inter_amount" class="w-full mb-2" v-if="!dataIntervention.invoice.id"/>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vs-input label="Email" v-model="dataIntervention.client.email" class="w-full mb-2" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-button id="copyBtn" class="w-full vs-con-loading__container"  color="primary" type="border" @click="generateUrl">copier le lien de paiement</vs-button>
        </div>
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-button id="sendBtn" class="w-full vs-con-loading__container"  color="success" type="border" @click="sendPUrl">Envoyer lien de paiement</vs-button>
        </div>
      </div>

      <p class="text-center text-success mt-5" v-if="sendSuccess == true"><feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" /> Le lien est bien envoyé.</p>
      <p class="text-center text-danger mt-5" v-if="sendSuccess == false"><feather-icon icon="AlertCircleIcon" svgClasses="h-4 w-4" /> Le lien de paiement n’a pas été envoyé. <br> Merci de bien vouloir réessayer</p>
        
      <p class="text-center text-success mt-5" v-if="copySuccess == true"><feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" /> Le lien est bien copié.</p>
      <p class="text-center text-danger mt-5" v-if="copySuccess == false"><feather-icon icon="AlertCircleIcon" svgClasses="h-4 w-4" /> Le lien de paiement n’a pas été copié. <br> Merci de bien vouloir réessayer</p>
    </vs-prompt>

    <vx-card>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/3 lg:w-1/3 mb-base">
          <vs-breadcrumb>
            <li><router-link to="/">Dashboard</router-link><span class="vs-breadcrum--separator">/</span></li>
            <li><router-link to="/interventions">Interventions</router-link><span class="vs-breadcrum--separator">/</span></li>
            <li aria-current="page" class="active" v-if="dataIntervention.id ">BI{{ dataIntervention.id | strPadStart('0') }}</li>
            <li aria-current="page" class="active" v-if="!dataIntervention.id ">Création d'intervention</li>
          </vs-breadcrumb>
        </div>
        <div class="vx-col w-full sm:w-2/3 lg:w-2/3 mb-base text-right">
          <vs-button type="line" line-origin="left" color="primary" class="ml-5" v-if="dataIntervention.invoice.id && !autoFactureId" @click="activePrompt = true"><feather-icon icon="FileTextIcon" svgClasses="h-4 w-4" /> Générer Auto-Facture</vs-button>
          <vs-button type="line" line-origin="left" color="primary" class="ml-5" v-if="dataIntervention.invoice.id && autoFactureId" :to="{ name: 'auto-facture', params: {id: autoFactureId.id }}"><feather-icon icon="FileTextIcon" svgClasses="h-4 w-4" /> {{ autoFactureId.num }}</vs-button>

          <vs-button type="line" line-origin="left" color="warning" class="ml-5" v-if="dataIntervention.id && !dataIntervention.invoice.id"><feather-icon icon="MailIcon" svgClasses="h-4 w-4" /> Envoyer une confirmation</vs-button>
          <vs-button type="line" line-origin="left" class="ml-5" @click="lienPaiementPrompt = true">
            <feather-icon icon="DollarSignIcon" svgClasses="h-4 w-4" /> Générer lien de paiement
          </vs-button>
          
          <vs-button type="line" line-origin="left" color="success" class="ml-5" v-if="dataIntervention.invoice.id && !dataIntervention.send_avis" @click="sendAvis(dataIntervention.id)"><feather-icon icon="SendIcon" svgClasses="h-4 w-4" /> Demander avis</vs-button>
          <vs-button type="line" line-origin="left" color="success" class="ml-5"v-if="dataIntervention.invoice.id && dataIntervention.send_avis" disabled><feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" /> Demande avis déjà envoyée</vs-button>
        </div>
      </div>


      <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit">

         <!-- tab intervention content -->
        <tab-content title="Intervention" class="mb-5" icon="feather icon-plus-square" :before-change="validateStep1">
          <!-- tab 1 content -->
            <form data-vv-scope="step-1">
              <intervention-tab :dataIntervention="dataIntervention" @showLoading="showLoading = true" @closeLoading="showLoading = false"></intervention-tab>
              <!-- @changeId="changeId($event)" -->
            </form>
        </tab-content>

        <!-- tab devis content -->
        <tab-content title="Devis" class="mb-5" icon="feather icon-file-text">
          <form data-vv-scope="step-2">
            <quote-tab :dataIntervention="dataIntervention" @showLoading="showLoading = true" @closeLoading="showLoading = false"></quote-tab>
          </form>
        </tab-content>

        <!-- tab facture content -->
        <tab-content title="Facture" class="mb-5" icon="feather icon-file-text">
          <form data-vv-scope="step-3">
            <invoice-tab :dataIntervention="dataIntervention" @showLoading="showLoading = true" @closeLoading="showLoading = false" @sendavisnow="sendAvis(dataIntervention.id)"></invoice-tab>
          </form>
        </tab-content>

         <!-- tab paiement content -->
        <tab-content title="Paiement" class="mb-5" icon="feather icon-dollar-sign">
          <form data-vv-scope="step-1">
          </form>
        </tab-content>

        <div slot="footer">

        </div>

      </form-wizard>
    </vx-card>

    <vs-prompt
      title= "Générer Auto-Facture"
      @accept="acceptAlert"
      accept-text= "Générer"
      cancel-text = "Annuler"
      :is-valid="validPrompt"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <table class="w-full">
          <tr>
            <td class="font-semibold w-1/3">N° intervention</td>
            <td class="pl-5">{{ dataIntervention.num }}</td>
          </tr>
          <tr>
            <td class="font-semibold w-1/3">Client</td>
            <td class="pl-5">{{ dataIntervention.client.id ? (dataIntervention.client.firstname +' '+ dataIntervention.client.lastname) : '' }}</td>
          </tr>
          <tr>
            <td class="font-semibold w-1/3">Artisan</td>
            <td class="pl-5">
              <v-select name="client_id" class="w-full mr-1" :clearable="false" label="fullName" v-model="first_selected_artisan_id" :options="Artisans_choices" :reduce="artisan => artisan.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </td>
          </tr>

        </table>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import interventionTab from './intervention_tab'
import quoteTab from './quote_tab'
import invoiceTab from './invoice_tab'

import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
  custom: {
    date_intervention: {
      required: 'La date d\'intervention est obligatoire'
    },
    lieu_intervention: {
      required: 'Le lieu d\'intervention est obligatoire'
    },
    description_intervention: {
      required: 'La description de problème est obligatoire'
    },
    categorie_intervention : {
      required: 'La catégorie d\'intervention est obligatoire'
    },

    client_email : {
      required: 'L\'email de client est obligatoire'
    },
    client_tel : {
      required: 'Le téléphone de client est obligatoire'
    },
    client_city : {
      required: 'La ville de client est obligatoire'
    },
    client_zipcode : {
      required: 'Le code postal de client est obligatoire'
    },
    client_address : {
      required: 'L\'adresse de client est obligatoire'
    },
    sub_categorie_intervention: {
      required: 'Le type de problème est obligatoire'
    }


  }
};

// register custom messages
Validator.localize('fr', dict);

export default {

  components: {
    VuePerfectScrollbar,
    FormWizard,
    TabContent,
    interventionTab,
    quoteTab,
    invoiceTab,
    vSelect
  },
  props: ['id'],
  data () {
    return {
      dataIntervention: {
        id: null,
        num: null,
        date: new Date(),
        lieu: null,
        status: {label: 'En cours', value: 2},
        description: null,
        note: null,
        emergency : {label: 'Sur rendez-vous', value: 0},
        categorie : null,
        subcategorie : null,
        client_id: null,
        send_rappel: null,
        send_avis: null,
        amount: null,
        secteur_id: null,
        client: {
          id: null,
          address: null,
          company: null,
          email: null,
          firstname: null,
          lastname: null,
          siret: null,
          status: null,
          tel: null,
          city: null,
          zipcode: null,
          emergency: null
        },
        quote: {
          object: null,
          id: null,
          num_quote: null,
          date: null,
          date_echeance : null,
          status:"issued",
          payment_type:"card",
          intervention_id:this.id,
          client_id:1,
          tva_value: 20,
          lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
          client:{firstname: null,lastname: null,siret: null,company:null,address:null,zipcode:null,city:null},
          reduction: false,
          historiques: []
        },
        price: null,
        artisans: [],
        historiques: [],
        auto_invoices: [],
        invoice: {
          object: null,
          id: null,
          num_quote: null,
          num_invoice: null,
          date: null,
          date_echeance : null,
          status:"issued",
          payment_type:"card",
          intervention_id:this.id,
          client_id:1,
          tva_value: 20,
          lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
          client:{firstname: null,lastname: null,siret: null,company:null,address:null,zipcode:null,city:null},
          reduction: false,
          historiques: []
        },
      },
   
      Status_choices : [
        {label: 'En attente', value: 0},
        {label: 'Valider', value: 1},
        {label: 'En cours', value: 2},
        {label: 'Terminer', value: 3},
        {label: 'Refuser', value: 4},
        {label: 'Annuler - trop chère', value: 5},
        {label: 'Annuler - artisan non disponible', value: 6},
        {label: 'Annuler - client annule', value: 7},
        {label: 'Annuler - hors secteur', value: 8},
        {label: 'Annuler - concurrence', value: 9},
      ],
      Emergency_choices : [
        {label: 'En urgence', value: 1},
        {label: 'Sur rendez-vous', value: 0}
      ],
      showLoading : false,
      activePrompt:false,
      first_selected_artisan_id: null,
      lienPaiementPrompt: false,
      inter_amount: null,
      inter_email: null,
      sendSuccess: null,
      copySuccess: null

    }
  },
  created () {

  },
  computed: {
    ...mapGetters('artisans', {'Artisans_choices' : 'GET_ITEMS'}),

    Interventionid: {
      get: function () {
        return this.id
      },
      set: function () {
      }
    },
    validPrompt() {
      return !!this.first_selected_artisan_id
    },
    autoFactureId() {
      return this.dataIntervention.auto_invoices.length ? {id: this.dataIntervention.auto_invoices[0].id ,num: this.dataIntervention.auto_invoices[0].num_auto_invoice} : null
    }
  },
  methods: {
    ...mapActions('interventions', {'getIntervention':'getItem', 'sendAvisRequest' : 'sendAvisRequest', 'generatePaiementUrl' : 'generatePaiementUrl', 'sendPaiementUrl': 'sendPaiementUrl'}),
    ...mapActions('artisans', {'fetchArtisans': 'fetchItems'}),

    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then(result => {
          if (result) {
            alert("Form submitted!");
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    validateStep4() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-4").then(result => {
          if (result) {
            alert("Form submitted!");
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    changeId(id) {
      this.Interventionid = id
    },

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    sendAvis(id) {
      this.sendAvisRequest(id).then(result => {
        this.dataIntervention.send_avis = result.data.intervention.send_avis
        this.successMsg("L'ajout","Demande d\'avis à été envoyée");
      }).catch(() => {
        this.errorMsg('Demander avis','Trouvé un error lor d\'envoi de demande')
      })
    },

    acceptAlert(){
      this.showLoading = true
      setTimeout(() => {
        this.showLoading = false
        setTimeout(() => {
          this.$router.push({ name: 'auto-facture', params: {intervention_id: this.dataIntervention.id,artisan_id: this.first_selected_artisan_id }})
        }, 100);
      }, 1000);
    },

    closeLienPaiementPrompt() {

    },
    sendPUrl() {
      if (!this.dataIntervention.invoice.id && !this.inter_amount) {
          this.sendSuccess = false

          setTimeout(() => {
              this.sendSuccess = null
          }, 5000);
      }else{
         

          if (!this.dataIntervention.client.email) {
            this.sendSuccess = false

            setTimeout(() => {
                this.sendSuccess = null
            }, 5000);
          }else{
            this.$vs.loading({
              background: '#fff',
              color: 'success',
              container: '#sendBtn',
              scale: 0.45
            })

            this.sendPaiementUrl({id: this.dataIntervention.id, amount: this.inter_amount, email: this.dataIntervention.client.email}).then(() => {
              this.sendSuccess = true
              this.$vs.loading.close('#sendBtn>.con-vs-loading')

              setTimeout(() => {
                  this.sendSuccess = null
              }, 5000);
            }).catch(() => {
                this.sendSuccess = false
                this.$vs.loading.close('#sendBtn>.con-vs-loading')

                setTimeout(() => {
                    this.sendSuccess = null
                }, 5000);
            })
          }
      }
    },
    generateUrl() {
      if (!this.dataIntervention.invoice.id && !this.inter_amount) {
          this.copySuccess = false

          setTimeout(() => {
              this.copySuccess = null
          }, 5000);
      }else{

        this.$vs.loading({
          background: '#fff',
          color: 'success',
          container: '#copyBtn',
          scale: 0.45
        })

        this.generatePaiementUrl({id: this.dataIntervention.id,  amount: this.inter_amount}).then(result => {
          const el = document.createElement('textarea');  
          el.value = result.data;                                 
          el.setAttribute('readonly', '');                
          el.style.position = 'absolute';                     
          el.style.left = '-9999px';                      
          document.body.appendChild(el);                  
          const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
          el.select();                                    
          document.execCommand('copy');                   
          document.body.removeChild(el);                  
          if (selected) {                                 
            document.getSelection().removeAllRanges();    
            document.getSelection().addRange(selected);   
        }
          this.copySuccess = true
          this.$vs.loading.close('#copyBtn>.con-vs-loading')

          setTimeout(() => {
              this.copySuccess = null
          }, 5000);

        }).catch(() => {
          this.copySuccess = false
          this.$vs.loading.close('#copyBtn>.con-vs-loading')

          setTimeout(() => {
              this.copySuccess = null
          }, 5000);
        })

      }
    }

  },
  mounted(){
    this.fetchArtisans()

    if(this.id) {
      this.showLoading = true
      this.getIntervention(this.id).then(result => {
        let intervention = result.data
        this.dataIntervention = {
          id: intervention.id,
          num: intervention.num,
          date: intervention.date_intervention,
          lieu: intervention.lieu,
          status: this.Status_choices[this.Status_choices.findIndex((p) => p.value == intervention.status)],
          description: intervention.description,
          note: intervention.note,
          emergency : this.Emergency_choices[this.Emergency_choices.findIndex((p) => p.value == intervention.emergency)],
          categorie : intervention.service_id,
          subcategorie: intervention.sub_service_id,
          client_id: intervention.client_id,
          send_rappel: intervention.send_rappel,
          send_avis: intervention.send_avis,
          amount: intervention.amount,
          secteur_id: intervention.secteur_id,
          client: {
            id: intervention.client.id,
            address: intervention.client.address,
            company: intervention.client.company,
            email: intervention.client.email,
            firstname: intervention.client.firstname,
            lastname: intervention.client.lastname,
            siret: intervention.client.siret,
            status: intervention.client.status,
            tel: intervention.client.tel,
            city: intervention.client.city,
            zipcode: intervention.client.zipcode,
            emergency: intervention.client.emergency
          },
          quote: intervention.quote ? intervention.quote : {
            object: null,
            id: null,
            api_id: null,
            num_quote: null,
            date: null,
            date_echeance: null,
            status:"issued",
            payment_type:"card",
            ht: 0,
            ttc: 0,
            tva: 0,
            intervention_id:this.id,
            client_id:intervention.client_id,
            tva_value: intervention.client.company ? 20 : 10,
            lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
            reduction: false,
            historiques : [],
          },
          price: intervention.price,
          artisans: intervention.artisans,
          historiques: intervention.historiques,
          auto_invoices: intervention.auto_invoices,
          invoice: intervention.invoice ? intervention.invoice : (intervention.quote ? {
            object: intervention.quote.object,
            id: null,
            api_id: null,
            num_quote: intervention.quote.num_quote,
            num_invoice: null,
            date: null,
            date_echeance: null,
            status:"issued",
            payment_type: intervention.quote.payment_type,
            ht: intervention.quote.ht,
            ttc: intervention.quote.ttc,
            tva: intervention.quote.tva,
            intervention_id: this.id,
            client_id: intervention.client_id,
            tva_value: intervention.quote.tva_value,
            lines: intervention.quote.lines,
            historiques : [],
            reduction: intervention.quote.reduction
          } : {
            object: null,
            id: null,
            api_id: null,
            num_quote: null,
            num_invoice: null,
            date: null,
            date_echeance: null,
            status:"issued",
            payment_type:"card",
            ht: 0,
            ttc: 0,
            tva: 0,
            intervention_id: this.id,
            client_id: intervention.client_id,
            tva_value: intervention.client.company ? 20 : 10,
            lines: [{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
            reduction: false
          })
        }
        if(!this.dataIntervention.invoice.lines.length){
          this.dataIntervention.invoice.lines = [{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}]
        }

        if(!this.dataIntervention.quote.lines.length){
          this.dataIntervention.quote.lines = [{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}]
        }

        if(this.dataIntervention.amount) this.inter_amount = this.dataIntervention.amount

        if(intervention.artisans.length) this.first_selected_artisan_id = intervention.artisans[0].id

        if(this.dataIntervention.client.email) this.inter_email = this.dataIntervention.client.email

        if(this.dataIntervention.historiques) {
          let timelineData = []
          this.dataIntervention.historiques.forEach((historique) => {
            var color = historique.action == "create" ? 'success' : 'warning'
            var icon = historique.action == "create" ? 'PlusIcon' : 'EditIcon'
            var title = historique.action == "create" ? 'Créé par '+historique.user.name : 'Modifié par '+historique.user.name
            timelineData.push({
              color: color,
              icon: icon,
              title: title,
              time: historique.date
            });
          })
          this.dataIntervention.historiques = timelineData
        }

        if(this.dataIntervention.invoice && this.dataIntervention.invoice.historiques) {
          let timelineData = []
          this.dataIntervention.invoice.historiques.forEach((historique) => {
            var color = historique.action == "create" ? 'success' : 'warning'
            var icon = historique.action == "create" ? 'PlusIcon' : 'EditIcon'
            var title = historique.action == "create" ? 'Créé par '+historique.user.name : 'Modifié par '+historique.user.name
            timelineData.push({
              color: color,
              icon: icon,
              title: title,
              time: historique.date
            });
          })
          this.dataIntervention.invoice.historiques = timelineData
        }

        if(this.dataIntervention.quote && this.dataIntervention.quote.historiques) {
          let timelineData = []
          this.dataIntervention.quote.historiques.forEach((historique) => {
            var color = historique.action == "create" ? 'success' : 'warning'
            var icon = historique.action == "create" ? 'PlusIcon' : 'EditIcon'
            var title = historique.action == "create" ? 'Créé par '+historique.user.name : 'Modifié par '+historique.user.name
            timelineData.push({
              color: color,
              icon: icon,
              title: title,
              time: historique.date
            });
          })
          this.dataIntervention.quote.historiques = timelineData
        }

        this.$refs.wizard.activateAll()
        this.showLoading = false


      })
    }
  },
  watch: {
    showLoading (val) {
      if(val == true){
        this.$vs.loading({type: 'radius', color: '#be092f'})
      }else{
        this.$vs.loading.close()
      }
    },
    Interventionid() {
      this.$refs.wizard.activateAll()
    },
    id(val) {
      if(!val) {
        this.dataIntervention = {
          id: null,
          date: new Date(),
          lieu: null,
          status: {label: 'En cours', value: 2},
          description: null,
          note: null,
          emergency : {label: 'Sur rendez-vous', value: 0},
          categorie : null,
          subcategorie : null,
          client_id: null,
          send_rappel: null,
          send_avis: null,
          amount: null,
          client: {
            id: null,
            address: null,
            company: null,
            email: null,
            firstname: null,
            lastname: null,
            siret: null,
            status: null,
            tel: null,
            city: null,
            zipcode: null,
            emergency: null
          },
          quote: {
            object: null,
            id: null,
            num_quote: null,
            date: null,
            date_echeance : null,
            status:"issued",
            payment_type:"card",
            intervention_id:this.id,
            client_id:1,
            tva_value: 20,
            lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
            client:{firstname: null,lastname: null,siret: null,company:null,address:null,zipcode:null,city:null},
            reduction: false,
            historiques: []
          },
          price: null,
          artisans: [],
          historiques: [],
          auto_invoices: [],
          invoice: {
            object: null,
            id: null,
            num_quote: null,
            num_invoice: null,
            date: null,
            date_echeance : null,
            status:"issued",
            payment_type:"card",
            intervention_id:this.id,
            client_id:1,
            tva_value: 20,
            lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
            client:{firstname: null,lastname: null,siret: null,company:null,address:null,zipcode:null,city:null},
            reduction: false,
            historiques: []
          }
        }

       this.$refs.wizard.reset()
      }
    }
  },
  filters:{
    strPadStart(value, pattern = ""){ // Use padStart to complete the string
      return value.toString().padStart(4,pattern)
    }
  }

}
</script>
<style scoped>
  .vs__selected{
    text-transform: uppercase;
  }
</style>
